export default "__VITE_ASSET__8AnefvLA__"